import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { SexualOrientation } from "Globals/Models/SexualOrientation";

export class SexualOrientationStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private sexualOrientation: SexualOrientation[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.sexualOrientation = initialState.sexualOrientations;
    }

    @MobX.action
    public getSexualOrientationName(sexualOrientationId: string | null): string {
        if (sexualOrientationId == "0" || sexualOrientationId == null || sexualOrientationId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => sexualOrientationId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): SexualOrientation[] {
        return this.sexualOrientation.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getSexualOrientationOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
